//TODO: get it from music context?/
export const availableValues = [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];


/*
grid - 1/8
-1 - previous
0 - pause
1 - C
2 - D
...
*/
//grid - 1/8
export const REFERENCE_INDIVIDUAL = [
	3, -1, 3, -1, 3, -1, -1, -1,
	3, -1, 3, -1, 3, -1, -1, -1,
	3, -1, 5, -1, 1, -1, -1, 2,
	3, -1, -1, -1, -1, -1, -1, -1,

	4, -1, 4, -1, 4, -1, -1, 4,
	4, -1, 3, -1, 3, -1, 3, 3,
	3, -1, 2, -1, 2, -1, 3, -1,
	2, -1, -1, -1, 5, -1, -1, -1,

	3, -1, 3, -1, 3, -1, -1, -1,
	3, -1, 3, -1, 3, -1, -1, -1,
	3, -1, 5, -1, 1, -1, -1, 2,
	3, -1, -1, -1, -1, -1, -1, -1,


	4, -1, 4, -1, 4, -1, -1, 4,
	4, -1, 3, -1, 3, -1, 3, 3,
	5, -1, 5, -1, 4, -1, 2, -1,
	1, -1, -1, -1, -1, -1, -1, -1
];


//ЧИЖИК
/*export const REFERENCE_INDIVIDUAL = [
	10, -1, 8, -1, 10, -1, 8, -1,
	11, -1, 10, -1, 9, -1, -1, -1,

	5, -1, 5, -1, 5, -1, 6, 7,
	8, -1, 8, -1, 8, -1, -1, -1,

	10, -1, 8, -1, 10, -1, 8, -1,
	11, -1, 10, -1, 9, -1, -1, -1,

	5, -1, 5, -1, 5, -1, 6, 7,
	8, -1, 8, -1, 8, -1, -1, -1,

	10, -1, 8, -1, 10, -1, 8, -1,
	11, -1, 10, -1, 9, -1, -1, -1,

	5, -1, 5, -1, 5, -1, 6, 7,
	8, -1, 8, -1, 8, -1, -1, -1,

	10, -1, 8, -1, 10, -1, 8, -1,
	11, -1, 10, -1, 9, -1, -1, -1,

	5, -1, 5, -1, 5, -1, 6, 7,
	8, -1, 8, -1, 8, -1, -1, -1
];

*/
export const SOVIET = [
	8, 6, -1, 8, -1, 9, -1, 12,
	-1, 11, -1, -1, -1, -1, -1, 11,

	12, 11, -1, 10, -1, 9, -1, 12,
	-1, 11, -1, -1, -1, -1, -1, -1,

	11, 11, -1, 10, -1, 11, -1, -1,
	9, -1, -1, -1, 0, 0, 0, 0,

	0, 0, 0, 5, 8, 9, 8, 7,
	0, 0, 0, 0, 0, 0, 0, 6
];


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/plugins/GA/lib/common.js